import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Room } from "../../../models/Room";
import { Fire } from "../../../services/FireClient";
import BotDocumentPart from "./BotDocumentPart";
import BotUtilityPart from "./BotUtilityPart";
import BotSoriPart from "./BotSoriPart";
import { useAppUIContext } from "../../../context/AppUIContext";
import { MyNotifs } from "../../../services/MyNotifs";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { Menu as MenuIcon } from "lucide-react";

export const RoomBotPage: React.FC = () => {
  const { roomId } = useParams<{ roomId: string; }>();
  const [room, setRoom] = useState<Room>();
  const { setIsMobileMenuOpen } = useAppUIContext();
  const [myNotifCount, setMyNotifCount] = useState(0);

  useEffect(() => {
    setMyNotifCount(MyNotifs.NrOfNew);
    const interval = setInterval(() => {
      setMyNotifCount(MyNotifs.NrOfNew);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    Fire.getRoom(roomId || "").then(r => {
      setRoom(r);
    });
  }, [roomId])

  return (
    <div className="flex flex-col h-full overflow-hidden bg-background md:rounded-panel md:border md:border-border">
      <header className="bg-background border-b px-2 md:px-6 py-2 md:py-4 flex items-center justify-between shrink-0 z-10">
        <div className="flex items-center gap-2 md:gap-4">
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden relative"
            onClick={() => setIsMobileMenuOpen(true)}
            data-cy='menu'
          >
            <MenuIcon className="w-6 h-6" />
            {myNotifCount > 0 && (
              <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center bg-destructive hover:bg-destructive/90 text-meta-sm">
                {myNotifCount > 9 ? '9+' : myNotifCount}
              </Badge>
            )}
          </Button>
          <h1 className="text-lg md:text-xl font-bold truncate">#{room?.name}</h1>
        </div>
      </header>

      {room && (
        <main className="flex-1 overflow-y-auto w-full max-w-3xl mx-auto p-4 md:p-6 space-y-4">
          <BotSoriPart room={room} />
          {room.bots?.some(b => b.type === 'ai-docubot') && <BotDocumentPart room={room} />}
          <BotUtilityPart room={room} />
        </main>
      )}
    </div>
  );
}

export default RoomBotPage;

/*
<IonSegment value={tab} onIonChange={e => setTab(e.detail.value as any)}>
  <IonSegmentButton value='general'><Trans>General bots</Trans></IonSegmentButton>
  <IonSegmentButton value='document'><Trans>Document bots</Trans></IonSegmentButton>
</IonSegment>
{tab == 'general' && <BotGeneralTab selectedBots={selectedBots} setSelectedBots={setSelectedBots} />}
{tab == 'document' && <BotDocumentTab selectedBots={selectedBots} setSelectedBots={setSelectedBots} />} 
*/